<div class="api-card">
  <div class="api-card__header">
    <div class="api-card__header-stack">
      <span class="api-card__title">Top endpoints</span>
      <span class="api-card__desc">Your busiest endpoints this period.</span>
    </div>
  </div>

  @if (endpoints.length) {
    <app-bar-list [rows]="rows" labelWidth="170px"></app-bar-list>
  } @else {
    <div class="empty-state">
      <p class="empty-state__title">No API calls in this range yet.</p>
      <p class="empty-state__desc">Once you start making requests, the breakdown will appear here.</p>
    </div>
  }

  <div class="api-card__footer">
    <a routerLink="/billing/usage" class="link">
      View all usage
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M4.5 2.5L8 6L4.5 9.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </a>
  </div>
</div>
